export class Controller {

    /** @ngInject */
    constructor($q, $state, AccountsResource, Alert) {
        this.$q = $q;
        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
    }

    $onInit() {
        this.email = this.account.profileEmailAddress;
    }

    send() {
        this.isSaving = true;
        this.$q
            .resolve(
                this.AccountsResource.sendVerificationEmail(this.companyId, this.account.id, this.email)
            )
            .then(() => this.$state.go('^', {}, {reload: '^'}))
            .then(() => this.Alert('success', 'company.user-directories.manage-account.send-verification-email.sent'))
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-account/send-verification-email/send-verification-email.controller.js